'use strict';

import angular from 'angular';


export default class SignupController {
  errors = {};
  submitted = false;

  constructor(Auth, $state, Config, $uibModal, $http) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.$state = $state;
    this.$uibModal = $uibModal;

    const generalConfig = Config.getModuleConfig(Config.Modules.General);
    const signUpConfig = Config.getModuleConfig(Config.Modules.SignUp);
    const profileConfig = Config.getModuleConfig(Config.Modules.Profile);

    const masterUrl = Config.getPlatformConfig().getMasterUrlWeb();

    $http({
      method: 'GET',
      url: masterUrl + '/api/settings/public/name/config.app'
    }).then(res => {
      let masterBusinessTypes = res.data.data.moduleConfig.general.businessTypes;
      let businessTypes = generalConfig.getBusinessTypes();
      let mergedAndSorted = [].concat(masterBusinessTypes, businessTypes).sort();
      this.businessTypes = [...new Set([... mergedAndSorted])];
    }, res => {
      this.businessTypes = generalConfig.getBusinessTypes();
    });

    this.states = ["AK","AL","AR","AZ","CA","CO","CT","DC","DE","FL","GA","GU","HI","IA","ID", "IL","IN","KS","KY","LA","MA","MD","ME","MH","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY", "OH","OK","OR","PA","PR","PW","RI","SC","SD","TN","TX","UT","VA","VI","VT","WA","WI","WV","WY"];

    this.user = {
      email: '',
      password: '',
      newsletter: true,
      profile: {
        address: [{
          street: '',
          street2: '',
          city: '',
          state: '',
          zip: ''
        }]
      }
    };
  }

  showPolicies() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      size: 'lg',
      animation: true,
      component: 'policiesAndProcedures',
      resolve: {}
    });
  }

  postTestimonial() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      size: 'md',
      animation: true,
      component: 'testimonialForm',
      resolve: {}
    });
  }

  register(form) {
    this.submitted = true;

    if(form.$valid) {

      this.user.profile.phone = [];
      this.user.profile.url = [];
      this.user.profile.socialMedia = [];
      this.user.profile.email = [{
        type: 'Work',
        address: this.user.email
      }];

      if (this.businessPhone) {
        this.user.profile.phone.push({
          type: 'Work',
          number: this.businessPhone
        })
      }

      if (this.cellPhone) {
        this.user.profile.phone.push({
          type: 'Cell',
          number: this.cellPhone,
          private: this.cellPhoneIsPrivate
        })
      }

      if (this.homePhone) {
        this.user.profile.phone.push({
          type: 'Home',
          number: this.homePhone
        })
      }

      if (this.fax) {
        this.user.profile.phone.push({
          type: 'Fax',
          number: this.fax
        })
      }

      if (this.websiteUrl) {
        this.user.profile.url.push({
          address: this.websiteUrl
        })
      }

      if (this.facebookUrl) {
        this.user.profile.socialMedia.push({
          type: 'Facebook',
          link: this.facebookUrl
        })
      }

      if (this.twitterUrl) {
        this.user.profile.socialMedia.push({
          type: 'Twitter',
          link: this.twitterUrl
        })
      }

      if (this.linkedInUrl) {
        this.user.profile.socialMedia.push({
          type: 'LinkedIn',
          link: this.linkedInUrl
        })
      }

      if (this.googleBusinessUrl) {
        this.user.profile.socialMedia.push({
          type: 'Google Business',
          link: this.googleBusinessUrl
        })
      }

      if (this.instagramUrl) {
        this.user.profile.socialMedia.push({
          type: 'Instagram',
          link: this.instagramUrl
        })
      }

      if (this.snapchatUrl) {
        this.user.profile.socialMedia.push({
          type: 'Snapchat',
          link: this.snapchatUrl
        })
      }

      if (this.yelpUrl) {
        this.user.profile.socialMedia.push({
          type: 'Yelp',
          link: this.yelpUrl
        })
      }

      this.user.profile.address[0].type = 'Work';

      return this.Auth.createUser(this.user)
        .then(() => {
          // Account created
          this.$state.go('registration-success');
        })
        .catch(err => {
          err = err.data;
          this.errors = {};
          // Update validity of form fields that match the mongoose errors
          if (err.name) {
            angular.forEach(err.errors, (error, field) => {
              form[field].$setValidity('mongoose', false);
              this.errors[field] = error.message;
            });
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/signup/signup.controller.js